import axios from "axios";

const api = axios.create({
  // Configurable per environment via .env (REACT_APP_API_URL).
  baseURL: process.env.REACT_APP_API_URL ,

  headers: { Accept: "application/json" },
});


api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
